import type { DirectDealsItemDetails, DirectDealsListItem } from '@openx/types/directDeals.ts';
import type { ConstValues } from '@openx/types/helpers.ts';
import type { AllTableCriteria, CriteriaChange, CriteriaDimension } from '@openx/types/tableCriteria.ts';
import type { PropsWithChildren } from 'react';
import type { DirectDealsListFilters } from '../../../types.ts';
import type { RequestDirectDealPayload } from '../../components/requestModal/form/types.ts';

export type DirectDealsConfig = {
  useDirectDealsListFetch: UseDirectDealsListFetch;
  useDirectDealsList: UseDirectDealsList;
  useDirectDealsDetailsFetch: UseDirectDealsDetailsFetch;
  useDirectDealsContact: UseDirectDealsContact;
};

export type DirectDealsProviderProps = PropsWithChildren<{
  directDealsConfig: DirectDealsConfig;
}>;

type UseDirectDealsListFetchResponse = {
  error?: Error;
  loading: boolean;
  directDealsItems: DirectDealsListItem[];
  tableCriteria: AllTableCriteria<DirectDealsListFilters>;
};

type UseDirectDealsListFetchArgs = {
  criteria: AllTableCriteria<DirectDealsListFilters>;
  skip?: boolean;
};

export type UseDirectDealsListFetch = ({
  criteria,
  skip,
}: UseDirectDealsListFetchArgs) => UseDirectDealsListFetchResponse;

export const DIRECT_DEALS_LIST_VIEW = {
  TABULAR: 'publishers_directDeals_tabular_view',
  TILE: 'publishers_directDeals_tile_view',
} as const;

export type DirectDealsListView = ConstValues<typeof DIRECT_DEALS_LIST_VIEW>;

type UseDirectDealsListReturnType = UseDirectDealsListFetchResponse & {
  viewType: DirectDealsListView;
  handleCriteriaChange: (criteria: CriteriaChange<CriteriaDimension, DirectDealsListFilters>) => void;
  handleChangeViewType: (type: DirectDealsListView) => void;
};

export type UseDirectDealsList = () => UseDirectDealsListReturnType;

export type UseDirectDealsDetailsFetchResponse = {
  error?: Error;
  loading: boolean;
  data: DirectDealsItemDetails;
};

export type UseDirectDealsDetailsFetch = (publisherId: string) => UseDirectDealsDetailsFetchResponse;

export type RequestContactArgs = {
  publisherId: string;
  publisherName: string;
  data: RequestDirectDealPayload;
  callback?: () => void;
};

export type UseDirectDealsContactReturnType = {
  requestContact: (args: RequestContactArgs) => Promise<void>;
  canContactAgain: boolean;
};

export type UseDirectDealsContact = (publisherId?: string) => UseDirectDealsContactReturnType;
